module.exports = __webpack_public_path__ + "img/recent_actors.2344c3cd.svg";